import React, { useEffect, useMemo, useState } from "react";
import { Table, Input, Button, Select, Modal, Spin, Tag, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import { toast } from "react-toastify";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import getAll from "../../../hooks/getAll";
import updateData from "../../../hooks/updateData";
import getOrderStatus from "../../../components/utils/getOrderStatus";

const { Option } = Select;

const ReturnOrders = () => {
  const [loading, setLoading] = useState(false);
  const [fetchToggle, setFetchToggle] = useState(false);
  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState();
  const [statusCode, setStatusCode] = useState();
  const [filterText, setFilterText] = useState("");
  const { t } = useTranslation();

  const getAllOrders = async (status_id) => {
    setLoading(true);
    let url = status_id >= 0 ? `vendor/getallreturn?status=${status_id}` : `vendor/getallreturn`;
    const response = await getAll(url);
    setData(response.status_code === 200 ? response.data : []);
    setLoading(false);
  };

  useEffect(() => {
    getAllOrders();
  }, [fetchToggle]);

  const handleStatusChange = (value) => {
    setStatusCode(value);
  };

  const handleAccepted = (id) => {
    setSelectedOrderId(id);
    setModalVisible(true);
  };

  const handleCancelRequest = async (id) => {
    setLoading(true);
    const res = await updateData("vendor/updateorder", { order_id: id, order_status: 10 });
    res.status_code === 200 ? toast.success("Updated Status!") : toast.error(res.message || res.err);
    setFetchToggle((prev) => !prev);
    setLoading(false);
  };

  const handleSubmit = async () => {
    if (!statusCode) return;
    setLoading(true);
    const res = await updateData("vendor/updateorder", {
      order_id: selectedOrderId,
      order_status: statusCode,
    });
    res.status_code === 200 ? toast.success("Updated Status!") : toast.error(res.message || res.err);
    setModalVisible(false);
    setFetchToggle((prev) => !prev);
    setLoading(false);
  };

  const filterByStatus = (status) => {
    getAllOrders(status);
  };

  const filteredData = useMemo(() => {
    return data?.filter((item) =>
      item?.cust_fullname?.toLowerCase().includes(filterText.toLowerCase()) ||
      item?.order_number?.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [filterText, data]);

  const columns = [
    {
      title: "ID",
      dataIndex: "order_id",
      key: "order_id",
      sorter: (a, b) => a.order_id - b.order_id,
    },
    {
      title: "Number",
      dataIndex: "order_number",
      key: "order_number",
    },
    {
      title: "Customer",
      dataIndex: "customer_email",
      key: "customer_email",
    },
    {
      title: "Status",
      dataIndex: "return_status",
      key: "return_status",
      render: (_, row) => getOrderStatus(row.order_status, "", { t }),
    },
    {
      title: "Date",
      dataIndex: "created_on",
      key: "created_on",
      render: (text) => moment(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Price",
      dataIndex: "order_price",
      key: "order_price",
      render: (text) => `${text} ر.س`,
    },
    {
      title: "Action",
      key: "action",
      render: (_, row) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            type="primary"
            size="small"
            onClick={() => handleAccepted(row.order_id)}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            size="small"
            onClick={() => handleCancelRequest(row.order_id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <h2 className="text-lg md:text-2xl pb-4">{t("Returns")}</h2>

      <div className="flex flex-wrap gap-2 mb-4">
        <Button onClick={() => filterByStatus(-1)}>{t("all")}</Button>
        <Button type="default" onClick={() => filterByStatus(4)}>{t("Return req")}</Button>
        <Button type="default" onClick={() => filterByStatus(5)}>{t("Request accepted")}</Button>
        <Button type="dashed" onClick={() => filterByStatus(8)}>{t("Refund successful")}</Button>
        <Button danger onClick={() => filterByStatus(10)}>{t("Request Cancelled")}</Button>
        <Input
          placeholder="Search by customer or number"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{ width: 250 }}
        />
      </div>

      {loading ? (
        <div className="flex justify-center">
          <Spin />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="order_id"
          pagination={{ pageSize: 10 }}
          locale={{ emptyText: t("No records") }}
        />
      )}

      <Modal
        title="Action For Return Request"
        open={modalVisible}
        onOk={handleSubmit}
        onCancel={() => setModalVisible(false)}
        okText="Update"
        cancelText="Cancel"
      >
        <div className="mb-3">Actions</div>
        <Select
          placeholder="Select Action"
          value={statusCode}
          onChange={handleStatusChange}
          style={{ width: "100%" }}
        >
          <Option value="5">Request accepted</Option>
          <Option value="10">Canceled Request</Option>
        </Select>
      </Modal>
    </>
  );
};

export default ReturnOrders;
